import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  decrement,
  fetchAnswerList,
  fetchQuestion,
  goBackByAmount,
  resetI,
} from "../../../../features/mobile/questionFoodAddSlice";
import HeadCont from "../../components/common/HeadCont";
import Message from "../../components/common/Message";
import QuestionForm from "../../components/question_addFood/QuestionForm";

const QuestionFoodAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { loginInfo } = useSelector((state) => state.commonApp);
  const { i, prevI, resultLists } = useSelector(
    (state) => state.questionFoodAdd
  );
  const closeIcon = useMemo(
    () => ({
      background: "url('/images/mobile/icon/close.svg') no-repeat center",
    }),
    []
  );
  const [openMessage, setOpenMessage] = useState(false);
  const onLeftAction = () => {
    if (i <= 0) {
      navigate(-1);
      window.scrollTo(0, 0);
    } else {
      if (prevI.length >= 2) {
        dispatch(goBackByAmount());
      } else if (prevI.length === 1) {
        //When i is 1
        dispatch(decrement());
      }
    }
  };

  useEffect(() => {
    if (!loginInfo?.userId) navigate(`/sign`);
    else {
      window.scrollTo(0, 0);
      dispatch(resetI());
      dispatch(fetchAnswerList(loginInfo.userId));
      dispatch(fetchQuestion());
    }
  }, [dispatch, loginInfo.userId, navigate]);
  return (
    <>
      {!openMessage ? (
        <>
          {/* onRightAction:
            Issue related to users taking survey after initial signup (when previous page is recommend or healthinfo, -1 doesn't work) - considered using api user/questionCheck, but for now navigating to home */}
          <HeadCont
            option={"progress"}
            onLeftAction={onLeftAction}
            rightIcon={closeIcon}
            onRightAction={() => navigate(location.state ? -1 : "/home")}
            i={i}
          />
          <section className="px-6 pt-2 mt-14">
            <QuestionForm
              onLeftAction={onLeftAction}
              setOpenMessage={setOpenMessage}
            />
          </section>
        </>
      ) : (
        <Message
          option={2}
          imgUrl={"/images/mobile/image/doctor_moniter.svg"}
          resultLists={resultLists}
        />
      )}
    </>
  );
};

export default QuestionFoodAdd;
